import { Button } from '@storeblocks/button';

import { InnerHtml, StatusLayout } from '@storebrand-digital/bank-foundation-components';
import { getText } from '@storebrand-digital/fms-translations';

import PageWithNavFooter from '../PageWithNavFooter';

export default function UnderMaintenancePage() {
  return (
    <PageWithNavFooter>
      <StatusLayout
        figure={<img src="https://assets.storebrand.no/icons/rebrand/broken-tree.svg" alt="" />}
        heading={{
          value: getText('underMaintenancePage.header'),
          level: 1,
          lookLike: 3,
        }}
        description={<InnerHtml html={getText('underMaintenancePage.description')} />}
        actions={
          <Button variant="secondary" onClick={() => window.location.reload()}>
            {getText('underMaintenancePage.reloadButton.text')}
          </Button>
        }
      />
    </PageWithNavFooter>
  );
}
